import { types } from '../types/loadingTypes';

type LoadingState = { show: boolean };
type LoadingAction = { type: string };

const defaultStore: LoadingState = {
	show: false,
};

export const loadingReducer = (
	state: LoadingState = defaultStore,
	action: LoadingAction,
) => {
	switch (action.type) {
		case types.show:
			return {
				...state,
				show: true,
			};

		case types.close:
			return {
				...state,
				show: false,
			};

		default:
			return state;
	}
};
